import * as React from 'react';
import { ConnectedDatePicker } from '@grandvisionhq/forms';

const CancellationDatePicker = ({ label , placeholder , errorMessage , minDate , dateFormat , name ='cancellationDate' , className ='cancel-subscription-form__date-picker'  })=>{
    return /*#__PURE__*/ React.createElement(ConnectedDatePicker, {
        name: name,
        className: className,
        label: label,
        placeholder: placeholder,
        errorMessage: errorMessage,
        minDate: minDate,
        dateFormat: dateFormat,
        required: true,
        autoComplete: false
    });
};

export { CancellationDatePicker };
//# sourceMappingURL=CancellationDatePicker.js.map
